module.exports = __webpack_public_path__ + "img/tw.e2db790e.svg";